import { NgModule } from '@angular/core';
import { NumbersOnlyDirective } from './numbers-only.directive';

@NgModule({
  imports: [],
  exports: [NumbersOnlyDirective],
  declarations: [NumbersOnlyDirective],
  providers: []
})
export class NumbersOnlyDirectiveModule {}
